<template>
  <section class="home">
    <div class="container">
      <!-- <video autoplay muted>
        <source src="@/assets/media/AH.mp4" type="video/mp4">
      </video> -->
      <img src="@/assets/media/AH.gif" alt="logo">
      <!-- <img src="@/assets/media/AH.gif" alt="Logo"> -->
      <router-link class="btn PrimaryButton" to="/works">{{ $t("my_work") }}</router-link>
      <socialMedia />
    </div>
  </section>
</template>

<script>
import socialMedia from '@/components/include/social/socialMedia.vue'

export default {
  name: "index-page",
  components: {
    socialMedia
  },
  // mounted() {
  //   const video = document.querySelector('video');
  //   if (video) {
  //     // console.log(video);
  //     video.playbackRate = 0.5;
  //   }
  // }
}
</script>

<style>

</style>